export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5600.21731144.jpg";